export default __webpack_public_path__ + "static/media/geslub_simbolo_principal.7483201c.png";